import { h, type Component, type VNodeChild } from 'vue';
import type { FormatterFactory } from '../types';
import ItpIcon from '../../icon/ItpIcon.vue';

export interface CheckmarkOptions {
  icon?: string;
  falseIcon?: string;
}

const DEFAULT_ICON = 'mdi:check';

export const checkmark: FormatterFactory = (options: CheckmarkOptions = {}) => {
  const renderer = (props: { value: any }): VNodeChild => {
    if (props.value === true || props.value === 1) {
      return h(ItpIcon, { icon: options.icon ?? DEFAULT_ICON });
    }
    return options.falseIcon ? h(ItpIcon, { icon: options.falseIcon }) : null;
  };

  renderer.props = ['value', 'context'];

  return { component: renderer as Component };
};
